<template>
  <div id="app" :style="appStyling">
    <player v-if="bookLoaded" :themeColor="themeColor" v-on:themecolorextracted="setThemeColor"></player>

    <template v-else>
      <div class="o-grid o-grid_full_h">
        <div class="o-grid__row">
          <div class="o-grid__cell u-tac u-vam o-wrapper">
            <error-message v-if="hasError" :error="error" />
            <successfully-returned-message v-else-if="successfullyReturned" :bookTitle="book.metadata.title" />

            <spinner v-else><p class="u-dimmed">{{ $t('loading') }}</p></spinner>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Spinner from './components/Spinner'
import ErrorMessage from './components/app_messages/Error'
import SuccessfullyReturnedMessage from './components/app_messages/SuccessfullyReturned'
import Player from './Player'
import { mapGetters } from 'vuex'

export default {
  name: 'app',

  components: {
    Spinner,
    ErrorMessage,
    SuccessfullyReturnedMessage,
    Player
  },

  data () {
    return {
      themeColor: [68, 68, 68]
    }
  },

  computed: {
    bookLoaded () {
      return !this.loading && !this.hasError && !this.successfullyReturned
    },

    hasError () {
      return !!this.error
    },

    appStyling () {
      return { backgroundColor: `rgb(${this.themeColor.join(',')})` }
    },

    ...mapGetters({
      'book': 'book',
      'error': 'error',
      'loading': 'loading',
      'successfullyReturned': 'bookSuccessfullyReturned'
    })
  },

  methods: {
    setThemeColor (rgb) {
      this.themeColor = rgb
    }
  },

  watch: {
    error () {
      this.setThemeColor([255, 85, 50]) // red
    }
  },

  mounted () {
    this.$store.dispatch('fetchBook')
    document.documentElement.lang = this.$i18n.locale
    document.title = `${this.$i18n.t('loading')}...`
  }
}
</script>

<style>
html {
  font-size: 14px;
  padding: 0;
  margin: 0;
  height: 100%;
}

body {
  background-color: #111;
  padding: 0;
  margin: 0;
  height: 100%;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
               Helvetica, Arial, sans-serif, "Apple Color Emoji",
               "Segoe UI Emoji", "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
}

body.is-locked {
  overflow: hidden;
}

[id="app"] {
  background-image: linear-gradient(rgba(17,17,17, 0.25), rgba(17,17,17, 1));
  background-repeat: no-repeat, repeat;
  background-attachment: fixed;
  transition: background-color 1s;
  height: 100%;
}

*, ::after, ::before {
  box-sizing: border-box;
}

a, button {
  color: rgba(255,255,255, 0.85);
}

:focus-visible {
  outline: 3px solid #fff;
}

a:hover,
button:hover {
  color: #fff;
}

a {
  text-decoration: none;
}

button {
  border: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;
  background-color: transparent;
  margin: 0;
  padding: 0;
}

h1 {
  font-weight: bold;
  font-size: 1.25em;
}

.button {
  display: inline-block;
  padding: 0.5em 1em;
  border: 1px solid rgba(255,255,255, 0.85);
  border-radius: 99px;
}

.button:hover {
  border-color: #fff;
}

.button_sm {
  padding: 0.25em 0.5em;
}

.button_xs {
  padding: 0.125em 0.35em;
}

.o-wrapper {
  max-width: 660px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5em;
  padding-right: 1.5em;
}

.o-grid {
  display: table;
  width: 100%;
}

.o-grid__row {
  display: table-row;
}

.o-grid__row_compact {
  height: 1px;
}

.o-grid__cell {
  display: table-cell;
}

.o-grid_full_h {
  height: 100%;
}

.u-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
}

.u-font-sm {
  font-size: 0.87em;
}

.u-font-lg {
  font-size: 1.25em;
}

.u-dimmed {
  opacity: 0.75;
}

.u-right {
  float: right;
}

.u-tal {
  text-align: left;
}

.u-tar {
  text-align: right;
}

.u-tac {
  text-align: center;
}

.u-vam,
.s-vam > * {
  vertical-align: middle;
}

.u-row-space-2 {
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue